import { routerService } from "cruzo";
import { routerUrlBucket } from "site/urls";

export function buildBooksEditorListHref(): string {
  return routerUrlBucket.buildUrl("books_editor");
}

export function buildBookEditorHref(bookId: number | string, returnTo?: string | null): string {
  const query = new URLSearchParams();
  if (returnTo) {
    query.set("return", returnTo);
  }
  return routerUrlBucket.buildUrl("book_editor", { bookId: String(bookId) }, query);
}

export function buildExerciseEditorHref(bookId: number | string, exerciseId: number | string): string {
  return routerUrlBucket.buildUrl("exercise_edit", {
    bookId: String(bookId),
    exerciseId: String(exerciseId),
  });
}

export function readBookEditorReturnParam(): string | null {
  const raw = new URLSearchParams(routerService.search$.actual).get("return");
  if (!raw) {
    return null;
  }
  return raw;
}
